import Config from '../launch/config'

export default class RadialGradientArc {
    constructor({
        diameter,
        innerColor,
        middleColor,
        outerColor,
        textureName,
        x,
        y,
    }) {
        diameter = diameter * 4
        const radius = diameter / 2
        const startX = radius
        const startY = radius
        const innerRadius = 2
        const outerRadius = 90
        const canvas = document.createElement('canvas')
        canvas.width = diameter
        canvas.height = diameter

        const ctx = canvas.getContext('2d')

        const radialGradient = ctx.createRadialGradient(
            startX,
            startY,
            innerRadius,
            startX - 20,
            startY - 20,
            outerRadius
        )
        radialGradient.addColorStop(0, innerColor)
        middleColor && radialGradient.addColorStop(0.5, `#${middleColor}`)
        radialGradient.addColorStop(0.9, outerColor)

        ctx.fillStyle = radialGradient
        ctx.arc(startX, startY, radius, 0, 2 * Math.PI)
        ctx.fill()

        Config.scene.textures.addCanvas(textureName, canvas)
        this.image = Config.scene.add.image(x, y, textureName)
        const scale = 0.5

        this.image.scaleX = scale
        this.image.scaleY = scale
        this.image.setDepth(3)
    }
}
